import { isProduction } from '../environment';
import { TenantApi as RealTenantApi } from './tenant-api';
import { TenantApi as MockTenantApi } from './mock-tenant-api';

const SelectedTenantApi = isProduction() ? RealTenantApi : MockTenantApi;

export default SelectedTenantApi;